<template>
    <div class="table-card table-card--form">
        <div class="table-card__stages">
            <div v-for="(stage,stages,index) in data.stages" :key="stage.id" 
                class="table-card__stages-item" 
                :class="{'active': currentStageNumber === stages}"
                @click="currentStageNumber = stages"
                >
                {{ stage.stage.name }} {{ index > 0 ? index : '' }} 
            </div>
        </div>
        <hr>
        <div class="table-card__title page-subtitle hidden-desc">Товары</div>
        <div class="table-wrap">
            <table class="table table--toggle">
                <thead class="table__head">
                <tr class="table__row">
                    <td class="table__col">№</td>
                    <td v-if="checkUserRole('supplier') && data?.type?.code === 'CO' && data.positions && checkStatus('активный')" class="table__col">Фото <br> или видео</td>
                    <td class="table__col">Наименование товара <br> Артикул ЕТУ</td>
                    <td class="table__col">Объем <br> партии</td>
                    <td v-if="checkUserRole('supplier') && canSendOffer" class="table__col">Подтвержденый <br> объём</td>


					<template v-if="checkUserRole('supplier')">
						<td v-if="checkStatus('активный')" class="table__col">
							<div class="table__col-title">
								<span>Валюта</span>
								<div class="tooltip tooltip--top">
									<span class="tooltip__icon"></span>
									<span class="tooltip__text">
                                    <div class="currencies-list">
                                        <div class="currencies-list__title">Выбранная вами валюта будет конвертирована в рубли по текущему курсу:</div>
                                        <div class="currencies-list__list">
                                            <template v-for="currency in currenciesList" :key="currency.id">
                                                <div v-if="!currency.isDefault" class="currencies-list__item">
                                                    <span>{{ currency.name }}</span>
                                                    <span>{{ currency.exchangeRate }}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </span>
								</div>
							</div>
						</td>
					</template>

					<template v-if="data?.type?.code === 'TN'">
						<td class="table__col">Цена</td>
					</template>

                    <!--для поставщика-->
                    <template v-if="checkUserRole('supplier') && canSendOffer">
						<td class="table__col">Предложение <br> цены</td>
						<td class="table__col">Способ, место город <br> доставки</td>
                    </template>
                    
                    <!--для админа или менеджера-->
                    <template v-if="checkUserRole('administrator') || checkUserRole('manager')">
                        <template v-if="!checkStatus('утверждён')">
                            <td class="table__col">Лучший <br> поставщик</td>
                        </template>
                    </template>
                    
                    <td  v-if="!checkUserRole('supplier')" class="table__col"></td>
                </tr>
                <tr class="table__margin">
                    <td colspan="100%"></td>
                </tr>
                </thead>
                <tbody class="table__body">
                <TenderInnerTableRow
                        v-for="(item, index) in data.positions"
                        :key="item.id"
                        :item="item"
                        :tender="data"
                        :number="index + 1"
                        :deliveryTypes="data.deliveries"
                        :deliveryPlaces="data.deliveryDestinations"
                        :can-send-offer="canSendOffer"
                        :stage="currentStageNumber"
                        :activeStage="activeStage"
                        @changeDeliveryType="handleShowDeliveryTypePopup"
                        @changeDeliveryPlace="handleShowDeliveryPlacePopup"
                        @changeDeliveryCity="handleShowDeliveryCityPopup"
                        @updateTender="this.$emit('updateTender')"
                />
                </tbody>
            </table>
        </div>
    </div>
	<message-block v-if="Object.values(data.stages).length > 1 && activeStage !== currentStageNumber" >
		<message-item :title="'Отправить предложение можно только на последнем этапе переторжки'" type-error></message-item>
	</message-block>
    <message-block v-if="showDeliveryMessage" >
        <message-item :title="'Для способа доставки «Доставка поставщиком» цена указывается с учетом стоимости доставки'" type-error></message-item>
    </message-block>
    <transition-group name="modal">
        <EditDeliveryTypePopup
                v-if="showEditDeliveryTypePopup"
                :id="currentPositionId"
                :options="data.deliveries"
                @close="showEditDeliveryTypePopup = false"
                @showDeliveryMessage="showWarning"
        />
        <EditDeliveryPlacePopup
                v-if="showEditDeliveryPlacePopup"
                :id="currentPositionId"
                :options="data.deliveryDestinations"
                @close="showEditDeliveryPlacePopup = false"
        />
        <EditDeliveryCityPopup
                v-if="showEditDeliveryCityPopup"
                :id="currentPositionId"
                :distCenterId="data.distrCenter.id"
                @close="showEditDeliveryCityPopup = false"
        />
    </transition-group>
</template>

<script>
import MessageBlock from "@/components/base/utils/message/MessageBlock.vue";
import MessageItem from "@/components/base/utils/message/MessageItem.vue";
import EditDeliveryTypePopup from "@/components/sections/LcSupply/SupplyTenders/SupplyTenderInner/EditDeliveryTypePopup.vue";
import EditDeliveryPlacePopup from "@/components/sections/LcSupply/SupplyTenders/SupplyTenderInner/EditDeliveryPlacePopup.vue";
import EditDeliveryCityPopup from "@/components/sections/LcSupply/SupplyTenders/SupplyTenderInner/EditDeliveryCityPopup.vue";
import {mapGetters, mapActions} from "vuex";
import TenderInnerTableRow from "@/components/sections/Tenders/TenderInner/TenderInnerTableRow.vue";

export default {
    name: "TenderInnerTable",
    components: {
        TenderInnerTableRow,
        EditDeliveryCityPopup,
        EditDeliveryPlacePopup, EditDeliveryTypePopup, MessageBlock, MessageItem
    },
    emits: ['updateTender'],
    props: {
        data: {
            type: Object,
            required: true,
        },
        canSendOffer: {
            type: Boolean,
            default: false,
        }
    },
    created() {
        this.currentStageNumber = Object.keys(this.data.stages).at(-1)
        this.activeStage = Object.keys(this.data.stages).at(-1)
    },
    data() {
        return {
            currentPositionId: null,
            currentStageNumber: 0,
            activeStage: 0,
            showEditDeliveryTypePopup: false,
            showEditDeliveryPlacePopup: false,
            showEditDeliveryCityPopup: false,
            showDeliveryMessage: false,
            fields: {
                price: null,
                deliveryType: null,
                deliveryCenter: null,
            }
        }
    },
    computed: {
        ...mapGetters({
            checkUserRole: 'user/checkUserRole',
            getOffersKey: 'tenders/getOffersKey',
            getOffers: 'tenders/getOffers',
            currenciesList: 'tenders/getCurrenciesList',
			getNewOfferTender: 'ws/getNewOfferTender'
        })
    },
    mounted() {
        if(this.checkUserRole('supplier')) {
            this.getOffers.forEach(offer => {
                if(offer.delivery === 2) {
                    this.showDeliveryMessage = true
                } 
            })
        }
    },

    methods: {
        checkStatus(status) {
            return this.data?.status?.name?.toLowerCase() === status;
        },
        toggleOther(e) {
            let parentTable = e.target.closest('.table__row')
            parentTable.nextElementSibling.classList.toggle('table__toggle-hidden')
            parentTable.classList.toggle('table__row--open')
        },
        toggleOtherMobile(e) {
            let parentTable = e.target.closest('.table__toggle')
            parentTable.classList.toggle('table__toggle-hidden')
            parentTable.previousElementSibling.classList.toggle('table__row--open')
        },
        handleShowDeliveryTypePopup(id) {
            this.currentPositionId = id;
            this.showEditDeliveryTypePopup = true;
        },
        handleShowDeliveryPlacePopup(id) {
            this.currentPositionId = id;
            this.showEditDeliveryPlacePopup = true;
        },
        handleShowDeliveryCityPopup(id) {
            this.currentPositionId = id;
            this.showEditDeliveryCityPopup = true;
        },
        showWarning(itsDelivery) {
            this.showDeliveryMessage = itsDelivery
        },
		...mapActions({
            requestTenderDetail: 'tenders/requestTenderDetail',
            requestMakeTenderOffer: 'tenders/requestMakeTenderOffer',
            updateOffersKey: 'tenders/updateOffersKey'
        })
    },
}
</script>


